import React, { useEffect, useState } from "react";
import logo from "../../assets/images/stuff/RAM_Logo.svg";
import home from "../../assets/images/stuff/home.svg";
import info from "../../assets/images/stuff/info.svg";
import expand from "../../assets/images/stuff/expand.svg";
import style from "./Navbar.module.css";
import Info from "../Info/Info";

const Navbar = ({ phase, setPhase, setOpenVideo }) => {
  const [logoStyle, setLogoStyle] = useState(null);
  const [firstStateOfPhase, setFirstStateOfPhase] = useState(0);
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    if (firstStateOfPhase === 0) {
      setLogoStyle(style.logo);
    }
    if (phase === 0 && firstStateOfPhase === 0) {
      setLogoStyle(style.logo);
      setFirstStateOfPhase(1);
    }
    if (phase > 0 && firstStateOfPhase !== 0) {
      setLogoStyle(style.logoSmaller);
    }
    if (phase === 0 && firstStateOfPhase !== 0) {
      setLogoStyle(style.logoBigger);
    }
  }, [phase]);

  return (
    <div className={style.navbar}>
      <div>
        <img src={logo} alt="logo" className={logoStyle} />
      </div>
      <div className={style.menu}>
        <img
          src={home}
          alt="home"
          style={{
            opacity: phase === 0 ? "0" : "1",
          }}
          onPointerDown={() => {
            setPhase(0);
            setOpenVideo(false);
          }}
          id="RAM_BTN_Nav_Home"
        />
        <img
          src={info}
          alt="info"
          style={{
            opacity: phase === 0 ? "0" : "1",
          }}
          onPointerDown={() => {
            if (phase === 0) return;
            setShowInfo(true);
            setOpenVideo(false);
          }}
          id="RAM_BTN_Nav_Info"
        />
        <img
          src={expand}
          alt="expand"
          onPointerDown={() => {
            setPhase(1);
            setOpenVideo(false);
          }}
          id="RAM_BTN_Nav_Expand"
        />
      </div>
      {showInfo && <Info setShowInfo={setShowInfo} />}
    </div>
  );
};

export default Navbar;
